import { render, staticRenderFns } from "./NewEvents.vue?vue&type=template&id=26fc78db"
import script from "./NewEvents.vue?vue&type=script&lang=js"
export * from "./NewEvents.vue?vue&type=script&lang=js"
import style0 from "./NewEvents.vue?vue&type=style&index=0&id=26fc78db&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports